import { ReactElement } from "react";
import Layout from "../../../components/layout";
import ShopBulkUpdateProductList from "../../../components/Shops/Products/BulkProductUpdate";

const ShopProductBulkUpdatePage = (): ReactElement => {
  return (
    <Layout>
      <ShopBulkUpdateProductList />
    </Layout>
  );
};

export default ShopProductBulkUpdatePage;
